import { FocusEvent } from "react";

export const selectInputOnFocus = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  // Delay the selection to next tick to ensure Mantine internal logic runs first
  setTimeout(() => {
    e.target.select();
  }, 0);
};
